export default __webpack_public_path__ + "static/media/proto.7fa273ff.svg";